import BillingPayment from '@/orm/models/Account/BillingPayment';
import { computed } from '@vue/composition-api';

export default function useBillingPayment() {
  const billingPayments = computed(() => BillingPayment.query().orderBy('id', 'desc').get());
  const metaData = computed(() => BillingPayment.getMetaData());

  async function fetchAll(params) {
    await BillingPayment.index(params);
  }

  async function deleteAll() {
    await BillingPayment.deleteAll();
  }

  return {
    billingPayments,
    metaData,
    fetchAll,
    deleteAll,
  };
}
